<template>
    <div>
        <v-dialog
            v-model="display"
            width="500"
            persistent>
            <v-card>
                <v-card-title>
                    {{ title }}
                    <v-spacer></v-spacer>
                    <v-switch v-model="form.is_taxable" :label="$t('taxable')" dense></v-switch>
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-autocomplete
                            label="Item"
                            :items="items"
                            item-text="name"
                            item-value="id"
                            v-model="form.item_id"
                            :rules="rules.item_id">
                            ></v-autocomplete>
                        <v-select
                            v-model="form.cast_type_id"
                            :rules="rules.cast_type_id"
                            :loading="loading.castTypes"
                            :disabled="loading.castTypes"
                            :label="$t('cast_type_title')"
                            :items="castTypes.data"
                            item-text="name"
                            item-value="id">
                        </v-select>
                        <v-text-field
                            v-model="form.quantity"
                            :rules="rules.quantity"
                            :label="$t('quantity')">
                        </v-text-field>
                        <v-select
                            v-model="form.measure_unit_id"
                            :items="item.measure_units"
                            :label="$t('unit_measure')"
                            :rules="rules.measure_unit_id"
                            item-text="name"
                            item-value="id">
                            >
                        </v-select>
                        <v-text-field
                            v-model="form.price_formated"
                            @change="formatCurrencyField('price')"
                            :rules="rules.price"
                            :label="$t('price')">
                        </v-text-field>
                        <v-text-field
                            readonly
                            :value="total"
                            :label="$t('total')">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn :disabled="!valid" @click="submit" text>
                        {{ $t('add_line_item') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <ItemSearchDialog
            @store="fillFromByItem"
            ref="itemSearchDialog"/>
    </div>
</template>

<script>
import RetryDialog from '@/components/common/RetryDialog';
import formatPrice from '@/utils/formatPrice';
import { mapActions, mapGetters } from 'vuex';
import ItemSearchDialog from '@/components/warehouse/ItemSearchDialog';
import fetchLookups from '@/utils/fetchLookups';
import formatAccounting from '@/utils/formatAccounting';
import {formatMoney} from 'accounting';
import {clone} from 'lodash';
// import PItemSearch from '../warehouse/PItemSearch.vue';

export default {
    name: "SalesOrderItemLineDialog",
    components: {
        RetryDialog,
        ItemSearchDialog,
        // PItemSearch
    },
     data() {
        return {
            display: false,
            valid:false,
            openParams: null,
            itemMeasureUnits: [],
            castTypes: [],
            loading: {
                data: false,
                castTypes: false,
                itemMeasureUnits: false
            },
            mode: {
                edit: false
            },
            form: {
                item: null,
                cast_type: null,
                item_id: null,
                cast_type_id: null,
                quantity: null,
                measure_unit: null,
                measure_unit_id: null,
                price: null,
                price_formated: null,
                row_id: null,
                is_taxable: false
            },
            rules: {
                item_id: [
                    v => !!v || this.$t('rules_required')
                ],
                cast_type_id: [
                    v => !!v || this.$t('rules_required')
                ],
                quantity: [
                    v => !!v || this.$t('rules_required')
                ],
                price : [
                    v => !!v || this.$t('rules_required')
                ],
                measure_unit_id : [
                    v => !!v || this.$t('rules_required')
                ]
            }
        }
    },
    computed: {
        ...mapGetters({
            items: "sales/item/items"
        }),
        title() {
            if(!this.mode.edit) return this.$t('new_item_line')
            else return this.$t('edit_item_line')
        },
        total() {
            return formatMoney(this.form.quantity * this.form.price, "SDG ", 2);
        },
        item() {
            if(!this.form.item_id) return {};
            return this.items.find(each => each.id == this.form.item_id);
        }
    },
    watch: {
    },
    methods: {
        formatPrice,
        fetchLookups,
        formatAccounting,
        ...mapActions("sales/castType", ["fetchCastTypes"]),
        open(params) {
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch(){
            try{
                if(this.mode.edit) {
                    this.form = JSON.parse(JSON.stringify(this.openParams.items));
                    this.form.price_formated = formatMoney(this.form.price, "SDG ", 2);
                }
                this.fetchLookups([{target: "castTypes", action: this.fetchCastTypes(), cached: true}]);
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"openDataFetch",message});
            }
        },
        setItemName(name) {
            this.form.item = name;
        },
        fillFromByItem(params) {
            this.form.item_obj = this.items.find(item => item.id == this.form.item_id);
            this.form.item = params.name;
            this.form.item_id = params.id;
            this.form.measure_unit_id = params.measure_unit_id;
            // this.fetchItemMeasureUnitsLookup(params.id)
        },
        submit() {
            this.form.cast_type = this.castTypes.data.find(each => each.id == this.form.cast_type_id).name;
            console.log(this.item.measure_units);
            this.form.measure_unit = this.item.measure_units.find(each => each.id == this.form.measure_unit_id).abbreviation;
            this.form.quantity = parseFloat(this.form.quantity);
            this.form.price = parseFloat(this.form.price);
            this.form.item = this.items.find(item => item.id == this.form.item_id).name;
            this.$emit('store', clone(this.form));
            this.close();
            this.form.row_id = null;
        },
        openItemSearchDialog() {
            this.form.item_id = null;
            this.$refs.itemSearchDialog.open(this.form.item);
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
            }
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
        },
        formatCurrencyField(field) {
            this.formatAccounting(field, "SDG")
        }
    },
}
</script>